import { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Image } from "react-bootstrap";
import arrowleft from "../images/arrowleft.png";
import arrowright from "../images/arrowright.png";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { motion } from "framer-motion";

const Testimonials = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const text = "We're crowd favourites";
  return (
    <div>
     <section className="testimonials-section container py-5">
      <h4 id="reviews" className="text-center section-title">TESTIMONIALS</h4>
      <h2 className="text-center testimonial-heading">
        {text.split(" ").map((word, wordIndex) => (
          <span key={wordIndex} style={{ display: "inline-block", whiteSpace: "nowrap" }}>
            {word.split("").map((letter, letterIndex) => (
              <motion.span
                key={letterIndex}
                whileInView={
                  word === "favourites"
                    ? {
                        y: letterIndex % 2 === 0 ? [-10, 10, 0] : [10, -10, 0],
                        color: ["#2E2178", "#2E2178", "#212121"],
                      }
                    : { rotateX: [0, 360], color: ["#212121", "#2E2178", "#212121"] }
                }
                transition={{
                  duration: 1.5,
                  ease: "easeInOut",
                  delay: letterIndex * 0.1,
                }}
                viewport={{ once: false, amount: 0.5 }}
                style={{
                  display: "inline-block",
                  transformOrigin: "center",
                }}
              >
                {letter}
              </motion.span>
            ))}
            <span>&nbsp;</span>
          </span>
        ))}
      </h2>

      <motion.div
        className="stars text-center"
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "5px",
          fontSize: "1.6rem",
          color: "#EECB20",
        }}
      >
        {["⭐", "⭐", "⭐", "⭐", "⭐"].map((star, index) => (
          <motion.span
            key={index}
            animate={{
              scale: [1, 1.2, 1],
              opacity: [1, 0.8, 1],
              y: index % 2 === 0 ? [-3, 3, -3] : [3, -3, 3],
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "easeInOut",
              delay: index * 0.3,
            }}
          >
            {star}
          </motion.span>
        ))}
      </motion.div>


      {!isMobile ? (
        <Carousel
        indicators={false}
        nextIcon={
          <span className="stand4">
            <motion.img
              src={arrowright}
              alt="Mockup"
              className="arrow-image1"
              style={{ maxWidth: "100%", overflow: "hidden" }}
              variants={{
                hidden: { x: 30, opacity: 0 },
                visible: { x: 0, opacity: 1, transition: { duration: 0.6, ease: "easeOut" } }
              }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
            />

          </span>
        }
        prevIcon={
          <span className="stand4">
            <motion.img
              src={arrowleft}
              alt="Mockup"
              className="arrow-image1"
              variants={{
                hidden: { x: -50, opacity: 0 },
                visible: { 
                  x: 0, 
                  opacity: 1, 
                  transition: { duration: 0.6, ease: "easeOut" } 
                }
              }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }} 
            />
          </span>
        }
      >
        <Carousel.Item>
            <p className="text-center testimonial-text">
              "The Deakin Alumni Communications team has engaged Sanny from Edu360 
              to provide custom email template construction and coding services for over 
              three years now. He is quick to respond to our needs, and we have achieved 
              the desired high-level outcomes with his support."
            </p>
            <h5 className="text-center testimonial-author">
              <strong>Gemma Willocks</strong> <span className="light-text">Alumni Engagement</span>
            </h5>
            <p className="text-center testimonial-company">DEAKIN UNIVERSITY</p>
          </Carousel.Item>

          <Carousel.Item>
            <p className="text-center testimonial-text">
              "Edu360 has been an incredible partner in helping us design and develop 
              our online learning solutions. The expertise and dedication of the team 
              have truly elevated our digital education offerings."
            </p>
            <h5 className="text-center testimonial-author">
              <strong>John Doe</strong> <span className="light-text"> Digital Learning Director</span>
            </h5>
            <p className="text-center testimonial-company">ABC INSTITUTE</p>
          </Carousel.Item>
        </Carousel>
      ) : (
        <Swiper
          style={{ width: "100vw", overflow: "hidden" }}
          pagination={{ clickable: true }}
          modules={[Pagination, Autoplay]}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop={true}
          className="swiper-container"
        >
          <SwiperSlide>
            <p className="text-center testimonial-text">
              "The Deakin Alumni Communications team has engaged Sanny from Edu360 
              to provide custom email template construction and coding services for over 
              three years now. He is quick to respond to our needs, and we have achieved 
              the desired high-level outcomes with his support."
            </p>
            <h5 className="text-center testimonial-author">
              <strong>Gemma Willocks</strong> <span className="light-text">Alumni Engagement</span>
            </h5>
            <p className="text-center testimonial-company">DEAKIN UNIVERSITY</p>
          </SwiperSlide>

          <SwiperSlide>
            <p className="text-center testimonial-text">
              "Edu360 has been an incredible partner in helping us design and develop 
              our online learning solutions. The expertise and dedication of the team 
              have truly elevated our digital education offerings."
            </p>
            <h5 className="text-center testimonial-author">
              <strong>John Doe</strong> <span className="light-text"> Digital Learning Director</span>
            </h5>
            <p className="text-center testimonial-company">ABC INSTITUTE</p>
          </SwiperSlide>
          <SwiperSlide>
            <p className="text-center testimonial-text">
              "Edu360 has been an incredible partner in helping us design and develop 
              our online learning solutions. The expertise and dedication of the team 
              have truly elevated our digital education offerings."
            </p>
            <h5 className="text-center testimonial-author">
              <strong>John Doe</strong> <span className="light-text"> Digital Learning Director</span>
            </h5>
            <p className="text-center testimonial-company">ABC INSTITUTE</p>
          </SwiperSlide>
          <SwiperSlide>
            <p className="text-center testimonial-text">
              "Edu360 has been an incredible partner in helping us design and develop 
              our online learning solutions. The expertise and dedication of the team 
              have truly elevated our digital education offerings."
            </p>
            <h5 className="text-center testimonial-author">
              <strong>John Doe</strong> <span className="light-text"> Digital Learning Director</span>
            </h5>
            <p className="text-center testimonial-company">ABC INSTITUTE</p>
          </SwiperSlide>
        </Swiper>
      )}
    </section>

    
     <section  id="contact" className="contact-section">
     <div className="contact-container">
       <div className="contact-text">
       <motion.h2
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: false, amount: 0.3 }}
        style={{ maxWidth: "100%", overflow: "hidden", textAlign: "center" }}
      >
        Let’s talk
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, scale: 1.2 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: false, amount: 0.3 }}
        style={{ maxWidth: "100%", overflow: "hidden", textAlign: "center" }}
      >
        Let’s have a chat about your website project and goals.
      </motion.p>
       </div>
       <form className="contact-form">
         <div className="form-group">
           <label>Name *</label>
           <input type="text" placeholder="Peter Smith" required />
         </div>
         <div className="form-group">
           <label>Email *</label>
           <input type="email" placeholder="peter.smith@monashuniversity.com.au" required />
         </div>
         <div className="form-group">
           <label>Phone *</label>
           <input type="text" placeholder="0419 188 732" required />
         </div>
         <div className="form-group">
           <label>Organisation *</label>
           <input type="text" placeholder="Monash University" required />
         </div>
         <div className="form-group full-width">
           <label>Enquiry *</label>
           <textarea placeholder="Hello, I would like to book a call to discuss my website" required></textarea>
         </div>
         <div className="d-flex newsletter justify-content-start ">
           <input type="checkbox" id="newsletter" />
           <label htmlFor="newsletter">Subscribe to our newsletter</label>
         </div>
         <div className="d-flex justify-content-end ">
          <button type="submit" className="send-button">
            SEND <Image className="arrowstand" src={arrowright} alt="Mockup" fluid />
          </button>
        </div>
       </form>
     </div>
   </section>

  
   <section className="marquee-section">
      <div className="marquee">
        <div className="marquee-content">
          <span>12 YEARS OF EXPERIENCE</span>
          <span className="separator">/</span>
          <span>PLAN, DESIGN AND BUILD WEBSITES</span>
          <span className="separator">/</span>
          <span>12 YEARS OF EXPERIENCE</span>
          <span className="separator">/</span>
          <span>PLAN, DESIGN AND BUILD WEBSITES</span>
          <div className="marquee-text">
            <span>12 YEARS OF EXPERIENCE</span>
            <span className="separator">/</span>
            <span>PLAN, DESIGN AND BUILD WEBSITES</span>
            <span className="separator">/</span>
            <span>12 YEARS OF EXPERIENCE</span>
            <span className="separator">/</span>
            <span>PLAN, DESIGN AND BUILD WEBSITES</span>
          </div>
        </div>
      </div>
    </section>
 </div>
  );
};

export default Testimonials;
